const all = ['patientImportantInformations']
const lists = [...all, 'list']
const listAll = (patientId: number) => [...lists, 'all', patientId]

export const patientImportantInformationsKeys = {
  all,
  lists,
  listAll,
}
